import { NoticePage } from '../components/common/NoticePage.js'

/** Replaces the respondent app for an Ethisphere Administrator: there is no admin-side
 *  view here yet, so the only way forward is to switch accounts. */
export function EthisphereAdminNotice() {
  return (
    <NoticePage icon="🔒" title="Ethisphere Administrator">
      Ethisphere Administrator cannot view this page. Please switch accounts to an Organization
      Administrator or an Organization User.
    </NoticePage>
  )
}
